import { useEffect } from 'react';
import { Box, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Header from 'components/layout/Header';
import DrawerBox from 'components/layout/DrawerBox';
import useMenu from 'hooks/useMenu';

function ManagerPage(): JSX.Element {
  const theme = useTheme();
  const { open, drawerOpen, drawerClose, handleDrawer } = useMenu();
  const matchDownLG = useMediaQuery(theme.breakpoints.down('md'));
  useEffect(() => {
    handleDrawer(!matchDownLG);
  }, [handleDrawer, matchDownLG]);

  const handleDrawerToggle = () => {
    handleDrawer(!open);
  };

  const backgroundColor = 'mind.custom.white';
  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Header open={open} drawerOpen={drawerOpen} drawerClose={drawerClose} />
      <DrawerBox open={open} handleDrawerToggle={handleDrawerToggle} />
      <Box component="main" sx={{ width: '100%', flexGrow: 1, p: 0 }}>
        <Toolbar />
        <Box
          sx={{
            p: { xs: 2, sm: 3 },
            backgroundColor,
            overflow: 'auto',
            height: 'calc(100vh - 64px)',
            width: open ? 'calc(100vw - 260px)' : 'calc(100vw)',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

export default ManagerPage;
